var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 450,
    viewBox: "0 0 450 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3908 155.626C38.9661 196.426 36.9412 243.262 53.1033 287.924C61.9157 312.298 75.3029 333.635 91.9151 351.373C198.638 465.295 351.185 387.784 344.323 309.073C339.598 255.037 297.374 234.937 195.526 235.912C118.465 236.662 78.1529 191.401 88.5027 128.927C60.4157 196.763 103.577 269.962 193.613 271.574C316.686 273.749 280.386 378.897 189.638 366.372C102.79 354.41 37.6911 265.537 55.3908 155.626ZM428.246 170.551C458.32 282.786 391.722 398.172 279.449 428.246C167.214 458.32 51.8284 391.722 21.754 279.449C-8.32046 167.214 58.2782 51.8284 170.551 21.754C282.786 -8.32046 398.172 58.2782 428.246 170.551ZM283.236 442.271C403.234 410.134 474.445 286.761 442.271 166.764C410.134 46.766 286.761 -24.4451 166.764 7.72923C46.766 39.8661 -24.4451 163.239 7.72923 283.236C39.8661 403.234 163.239 474.445 283.236 442.271ZM394.609 294.374C411.034 253.574 413.059 206.738 396.897 162.076C388.084 137.702 374.697 116.365 358.085 98.6275C251.362 -15.2953 98.7775 62.2157 105.677 140.927C110.402 194.963 152.626 215.063 254.474 214.088C331.535 213.338 371.847 258.599 361.497 321.073C389.584 253.237 346.423 180.038 256.387 178.426C133.314 176.251 169.614 71.103 260.362 83.6278C347.21 95.59 412.309 184.463 394.609 294.374Z",
    fill: "url(#paint0_linear_983_301)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_983_301",
    x1: 279.175,
    y1: 427.3,
    x2: 170.748,
    y2: 22.7055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5D3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE8FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.d815fc37edc26d5e2411b8328a65b9b1.svg";
export { ForwardRef as ReactComponent };